import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import thunkMiddleware from 'redux-thunk'

import rootReducer from './reducers'
import rootSaga from './sagas'

const sagaMiddleware = createSagaMiddleware()

const filterActionPropagation = () => next => action => {
    if (!action.type.startsWith('HANDLE_')) return next(action)
}

const middlewares = [thunkMiddleware, sagaMiddleware, filterActionPropagation]

const hideStore = process.env.REACT_APP_CUSTOM_NODE_ENV === 'PRODUCTION'

const composeEnhancers =
    (!hideStore &&
        typeof window !== 'undefined' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose

const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middlewares))
)

// finally run saga
sagaMiddleware.run(rootSaga)

export default store
